<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Base de conocimiento",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "Base de conocimiento",
    };
  },
  methods: {
    // Manual PESV alojado en el bucket (formatos de descarga: sst-prod/estandares).
    descargarManualPesv() {
      window.open(
        "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/sst-prod/estandares/MANUAL_PESV.pdf"
      );
    },
  },


};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">

        <div class="row">




          <div class="col-3 m-0">
            <a href="/forms/sg-sst">
              <div class="card text-white border-primary bg-white mb-3 card-spacer-y: " style="max-width: 18rem;">
                <div class="card-body">
                  <h5 class="card-title text-primary">SG SST</h5>
                  <div class="row">

                    <div class="col-md-4">
                      <i class="pl-2 mdi mdi-library mdi mdi-48px text-primary"></i>
                    </div>
                    <div class="col-md-8">

                      <input type="checkbox" class="read-more-state" id="post-1" />
                      <p class="read-more-wrap text-dark">La definición del sistema de gestión de<span
                          class="read-more-target"><br /> SST (SG-SST), está incluida en el Artículo 2.2.4.6.4 del
                          Decreto 1072 de 2015</span></p>
                      <label m-0 for="post-1" class="read-more-trigger text-dark"></label>
                    </div>

                  </div>


                </div>
              </div>
            </a>
          </div>

          <div class="col-3">
            <a href="/forms/copasst">
              <div class="card text-white border-primary bg-white mb-3 card-spacer-y: " style="max-width: 18rem;">
                <div class="card-body">
                  <h5 class="card-title text-primary">Comité copasst</h5>

                  <div class="row">

                    <div class="col-md-4">
                      <i class="pl-2 mdi mdi-book-account-outline mdi-48px text-primary"></i>
                    </div>
                    <div class="col-md-8">

                      <input type="checkbox" class="read-more-state" id="post-2" />
                      <p class="read-more-wrap text-dark">El Comité Paritario de Seguridad y Salud<span
                          class="read-more-target"><br />en el Trabajo más conocido como COPASST, está reglamentado en
                          Colombia por la Resolución 2013 de 1986, siendo este organismo un apoyo fundamental para la
                          gestión de la seguridad y salud en el trabajo. </span></p>
                      <label m-0 for="post-2" class="read-more-trigger text-dark"></label>
                    </div>

                  </div>

                </div>
              </div>
            </a>
          </div>

          <div class="col-3">
            <a href="/forms/capacitacion">
              <div class="card text-white border-primary bg-white mb-3 card-spacer-y: " style="max-width: 18rem;">
                <div class="card-body">
                  <h5 class="card-title text-primary">Capacitación copasst</h5>

                  <div class="row">

                    <div class="col-md-4">
                      <i class="pl-2 mdi mdi-book-multiple mdi-lg mdi-48px text-primary"></i>
                    </div>
                    <div class="col-md-8">

                      <input type="checkbox" class="read-more-state" id="post-3" />
                      <p class="read-more-wrap text-dark">Una vez conformado el Comité Paritario <span
                          class="read-more-target"><br />de Seguridad y Salud en el Trabajo Copasst, se deberá planear
                          la primera reunión y capacitarlos inicialmente en funciones, roles y responsabilidades del
                          comité</span></p>
                      <label m-0 for="post-3" class="read-more-trigger text-dark"></label>
                    </div>

                  </div>

                </div>
              </div>
            </a>
          </div>

          <div class="col-3">
            <a href="/forms/convivencia">
              <div class="card text-white border-primary bg-white mb-3 card-spacer-y: " style="max-width: 18rem;">
                <div class="card-body">
                  <h5 class="card-title text-primary">Comité convivencia</h5>
                  <div class="row">

                    <div class="col-md-4">
                      <i class="pl-2 mdi mdi-book-open mdi-48px text-primary"></i>
                    </div>
                    <div class="col-md-8">

                      <input type="checkbox" class="read-more-state" id="post-4" />
                      <p class="read-more-wrap text-dark">Es un grupo de empleados, <span
                          class="read-more-target"><br />conformado por representantes del empleador y representantes de
                          los empleados, que busca prevenir el acoso laboral contribuyendo a proteger a los empleados
                          contra los riesgos psicosociales que afectan la salud en los lugares de trabajo.</span></p>
                      <label m-0 for="post-4" class="read-more-trigger text-dark"></label>
                    </div>

                  </div>

                </div>
              </div>
            </a>
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <a href="/forms/medicina">
              <div class="card text-white border-primary bg-white mb-3 card-spacer-y: " style="max-width: 18rem;">
                <div class="card-body">
                  <h5 class="card-title text-primary">Evaluación medica ocupacional</h5>
                  <div class="row">

                    <div class="col-md-4">
                      <i class="pl-2 mdi mdi-medical-bag mdi-48px text-primary"></i>
                    </div>
                    <div class="col-md-8">

                      <input type="checkbox" class="read-more-state" id="post-5" />
                      <p class="read-more-wrap text-dark">La evaluación médica ocupacional es <span
                          class="read-more-target"><br />un acto médico mediante el cual se interroga y examina a un
                          trabajador, con el fin de monitorear la exposición a factores de riesgo y determinar la
                          existencia de consecuencias en la persona por dicha exposición.</span></p>
                      <label m-0 for="post-5" class="read-more-trigger text-dark"></label>
                    </div>

                  </div>

                </div>
              </div>
            </a>
          </div>

          <div class="col-3">
            <a href="/forms/curso">
              <div class="card text-white border-primary bg-white mb-3 card-spacer-y: " style="max-width: 18rem;">
                <div class="card-body">
                  <h5 class="card-title text-primary">Curso de 50 horas</h5>
                  <div class="row">

                    <div class="col-md-4">
                      <i class="pl-2 mdi mdi-blur mdi-48px text-primary"></i>
                    </div>

                    <div class="col-md-8">

                      <input type="checkbox" class="read-more-state" id="post-6" />
                      <p class="read-more-wrap text-dark">Es una capacitación obligatoria, para<span
                          class="read-more-target"><br />desarrollar competencias en las personas que en su trabajo
                          tengan relación con el Sistema de Gestión de la Seguridad y Salud en el trabajo SG-SST </span>
                      </p>
                      <label m-0 for="post-6" class="read-more-trigger text-dark"></label>
                    </div>

                  </div>


                </div>
              </div>
            </a>
          </div>

          <div class="col-3">
            <a href="/forms/accidentes">
              <div class="card text-white border-primary bg-white mb-3 card-spacer-y: " style="max-width: 18rem;">
                <div class="card-body">
                  <h5 class="card-title text-primary m-0">Accidentes de trabajo y enfermedades laborales</h5>
                  <div class="row">

                    <div class="col-md-4">
                      <i class="pl-2 mdi mdi-nuke mdi-48px text-primary"></i>
                    </div>
                    <div class="col-md-8">

                      <input type="checkbox" class="read-more-state" id="post-7" />

                      <p class="read-more-wrap text-dark m-1">Se define el accidente de trabajo <span
                          class="read-more-target"><br />como “Todo suceso repentino que sobrevenga por causa o con
                          ocasión del trabajo, y que produzca en el trabajador una lesión orgánica, una perturbación
                          funcional o psiquiátrica, una invalidez o la muerte.</span></p>

                      <label m-0 for="post-7" class="read-more-trigger text-dark"></label>
                    </div>

                  </div>

                </div>
              </div>
            </a>
          </div>

          <div class="col-3">
            <a href="/forms/elemento">
              <div class="card text-white border-primary bg-white mb-3 card-spacer-y: " style="max-width: 18rem;">
                <div class="card-body">
                  <h5 class="card-title text-primary m-0">Elementos de protección personal (EPP).</h5>
                  <div class="row">

                    <div class="col-md-4">
                      <i class="pl-2 mdi mdi-account-cog-outline mdi-48px text-primary"></i>
                    </div>
                    <div class="col-md-8">

                      <input type="checkbox" class="read-more-state" id="post-8" />

                      <p class="read-more-wrap text-dark m-1">El Elemento de Protección Personal<span
                          class="read-more-target"><br />(EPP), es cualquier equipo o dispositivo destinado para ser
                          utilizado o sujetado por el trabajador, para protegerlo de uno o varios riesgos y aumentar su
                          seguridad o su salud en el trabajo</span></p>

                      <label m-0 for="post-8" class="read-more-trigger text-dark"></label>
                    </div>

                  </div>

                </div>
              </div>
            </a>
          </div>

          <div class="col-3">
            <a href="/forms/prevencion">
              <div class="card text-white border-primary bg-white mb-3 card-spacer-y: " style="max-width: 18rem;">
                <div class="card-body">
                  <h5 class="card-title text-primary m-0">Plan de prevención, preparación y respuesta ante emergencias
                  </h5>
                  <div class="row">

                    <div class="col-md-4">
                      <i class="pl-2 mdi mdi-hand mdi-48px text-primary"></i>
                    </div>
                    <div class="col-md-8">

                      <input type="checkbox" class="read-more-state" id="post-9" />

                      <p class="read-more-wrap text-dark m-1">Todas las empresas deben implementar<span
                          class="read-more-target"><br />y mantener acciones en materia de prevención, preparación y
                          respuesta ante emergencias, que incluya todos los centros, turnos de trabajo y todos los
                          trabajadores, independiente de su forma de contratación o vinculación, incluidos contratistas
                          y subcontratistas, así como proveedores y visitantes</span></p>

                      <label m-0 for="post-9" class="read-more-trigger text-dark"></label>
                    </div>

                  </div>

                </div>
              </div>
            </a>
          </div>
          <div class="col-3">
            <a href="/forms/actividades-medicina">
              <div class="card text-white border-primary bg-white mb-3 card-spacer-y: " style="max-width: 18rem;">
                <div class="card-body">
                  <h5 class="card-title text-primary m-0">Programa de promoción y prevención en salud</h5>
                  <div class="row">

                    <div class="col-md-4">
                      <i class="pl-2 mdi mdi-hand mdi-48px text-primary"></i>
                    </div>
                    <div class="col-md-8">

                      <input type="checkbox" class="read-more-state" id="post-10" />

                      <p class="read-more-wrap text-dark m-1">Se realizan para prevenir <span
                          class="read-more-target"><br />posibles riesgos asociados al desarrollo de las actividades
                          laborales de una empresa.</span></p>

                      <label m-0 for="post-10" class="read-more-trigger text-dark"></label>
                    </div>

                  </div>

                </div>
              </div>
            </a>
          </div>

          <div class="col-3">
            <a href="/forms/phva">
              <div class="card text-white border-primary bg-white mb-3 card-spacer-y: " style="max-width: 18rem;">
                <div class="card-body">
                  <h5 class="card-title text-primary">PHVA</h5>
                  <div class="row">

                    <div class="col-md-4">
                      <i class="pl-2 mdi mdi-blur mdi-48px text-primary"></i>
                    </div>

                    <div class="col-md-8">

                      <input type="checkbox" class="read-more-state" id="post-11" />
                      <p class="read-more-wrap text-dark">Planear, hacer, verificar y actuar
                        <span class="read-more-target"><br />
                          El ciclo PHVA es un método de mejoras continuas.</span>
                      </p>
                      <label m-0 for="post-11" class="read-more-trigger text-dark"></label>
                    </div>

                  </div>


                </div>
              </div>
            </a>
          </div>

          <div class="col-3">
            <a href="/forms/sustancias-quimicas">
              <div class="card text-white border-primary bg-white mb-3 card-spacer-y: " style="max-width: 18rem;">
                <div class="card-body">
                  <h5 class="card-title text-primary">Manejo de sustancias químicas</h5>
                  <div class="row">

                    <div class="col-md-4">
                      <i class="pl-2 mdi mdi-nuke mdi-48px text-primary"></i>
                    </div>

                    <div class="col-md-8">

                      <input type="checkbox" class="read-more-state" id="post-12" />
                      <p class="read-more-wrap text-dark">La utilización de sustancias o compuestos químicos
                        <span class="read-more-target"><br />y sus derivados que se utilizan de manera directa, o a
                          través de sus productos
                          procedentes como plásticos, fibras sintéticas, pinturas, pegantes, tintas, pigmentos,
                          insecticidas, combustibles, y otros.</span>
                      </p>
                      <label m-0 for="post-12" class="read-more-trigger text-dark"></label>
                    </div>

                  </div>


                </div>
              </div>
            </a>
          </div>

          <div class="col-3">
            <a href="/forms/procedimiento-auditoria">
              <div class="card text-white border-primary bg-white mb-3 card-spacer-y: " style="max-width: 18rem;">
                <div class="card-body">
                  <h5 class="card-title text-primary">Procedimiento de auditoría</h5>
                  <div class="row">

                    <div class="col-md-4">
                      <i class="pl-2 mdi mdi-account-edit mdi-48px text-primary"></i>
                    </div>

                    <div class="col-md-8">

                      <input type="checkbox" class="read-more-state" id="post-13" />
                      <p class="read-more-wrap text-dark">La ISO 9001:2015 define a la auditoría como
                        <span class="read-more-target"><br />"Proceso sistemático, independiente y documentado para
                          obtener evidencias objetivas y evaluarlas
                          de manera objetiva con el fin de determinar el grado en el que se cumplen los criterios de
                          auditoria".</span>
                      </p>
                      <label m-0 for="post-13" class="read-more-trigger text-dark"></label>
                    </div>

                  </div>


                </div>
              </div>
            </a>
          </div>

          <div class="col-3">
            <a href="/forms/mecanismo-comunicacion">
              <div class="card text-white border-primary bg-white mb-3 card-spacer-y: " style="max-width: 18rem;">
                <div class="card-body">
                  <h5 class="card-title text-primary">Mecanismo de comunicaciones</h5>
                  <div class="row">

                    <div class="col-md-4">
                      <i class="pl-2 mdi mdi-account-switch mdi-48px text-primary"></i>
                    </div>

                    <div class="col-md-8">

                      <input type="checkbox" class="read-more-state" id="post-14" />
                      <p class="read-more-wrap text-dark">El mecanismo de comunicaciones se define como
                        <span class="read-more-target"><br />"Todas las empresas deben disponer de canales para manejar
                          las comunicaciones internas y externas, para esto se pueden utilizar los diferentes mecanismos
                          dispuestos por la empresa: Carteleras, capacitaciones, correos electrónicos, buzones de
                          sugerencias, intranet entre otros.".</span>
                      </p>
                      <label m-0 for="post-14" class="read-more-trigger text-dark"></label>
                    </div>

                  </div>


                </div>
              </div>
            </a>
          </div>

          <div class="col-3">
            <a href="/forms/especificaciones-sst-adquisiciones">
              <div class="card text-white border-primary bg-white mb-3 card-spacer-y: " style="max-width: 18rem;">
                <div class="card-body">
                  <h5 class="card-title text-primary">Especificaciones sst adquisiciones</h5>
                  <div class="row">

                    <div class="col-md-4">
                      <i class="pl-2 mdi mdi-clipboard-text mdi-48px text-primary"></i>
                    </div>

                    <div class="col-md-8">

                      <input type="checkbox" class="read-more-state" id="post-15" />
                      <p class="read-more-wrap text-dark">Las especificaciones SST adquisiciones se definen como
                        <span class="read-more-target"><br />"Garantizar que los suministros, materiales, equipo y
                          contrataciones que se realicen para la empresa cumplan con los requisitos cumplimiento con
                          requisitos de SG SST.".</span>
                      </p>
                      <label m-0 for="post-15" class="read-more-trigger text-dark"></label>
                    </div>

                  </div>


                </div>
              </div>
            </a>
          </div>

          <div class="col-3">
            <a href="/forms/procedimiento-acciones-correctivas">
              <div class="card text-white border-primary bg-white mb-3 card-spacer-y: " style="max-width: 18rem;">
                <div class="card-body">
                  <h5 class="card-title text-primary">Procedimiento de acciones correctivas y preventivas</h5>
                  <div class="row">

                    <div class="col-md-4">
                      <i class="pl-2 mdi  mdi-alert-octagon mdi-48px text-primary"></i>
                    </div>

                    <div class="col-md-8">

                      <input type="checkbox" class="read-more-state" id="post-16" />
                      <p class="read-more-wrap text-dark">Este documento establece
                        <span class="read-more-target"><br />"políticas, responsabilidades y controles para implementar y
                          supervisar acciones preventivas y correctivas en el Sistema de Gestión de Seguridad y Salud en el Trabajo,
                          asegurando la identificación, mitigación y eliminación de no conformidades que afectan su desempeño.".</span>
                      </p>
                      <label m-0 for="post-16" class="read-more-trigger text-dark"></label>
                    </div>

                  </div>


                </div>
              </div>
            </a>
          </div>

          <div class="col-3">
            <div class="card text-white border-primary bg-white mb-3 card-spacer-y: " style="max-width: 18rem;">
              <div class="card-body">
                <h5 class="card-title text-primary m-0">PESV - Plan Estratégico de Seguridad Vial</h5>
                <div class="row">

                  <div class="col-md-4">
                    <i class="pl-2 mdi mdi-car-traction-control mdi-48px text-primary"></i>
                  </div>

                  <div class="col-md-8">

                    <input type="checkbox" class="read-more-state" id="post-17" />
                    <p class="read-more-wrap text-dark m-1">El PESV es el instrumento de planificación
                      <span class="read-more-target"><br />que define acciones, mecanismos, estrategias y medidas
                        que deben adoptar las entidades, organizaciones o empresas para prevenir los accidentes de
                        tránsito y reducir sus impactos, según la Resolución 40595 de 2022.</span>
                    </p>
                    <label m-0 for="post-17" class="read-more-trigger text-dark"></label>
                  </div>

                </div>

                <button type="button" class="btn btn-primary btn-sm w-100 mt-2" @click="descargarManualPesv()">
                  <i class="mdi mdi-download mr-1"></i> Manual Plan Estratégico de Seguridad Vial
                </button>

              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </Layout>
</template>


<style>
.read-more-state {
  display: none;
}

.read-more-target {
  opacity: 0;
  max-height: 0;
  font-size: 0;
  transition: .10s ease;
}

.read-more-state:checked~.read-more-wrap .read-more-target {
  opacity: 1;
  font-size: inherit;
  max-height: 999em;
}

.read-more-state~.read-more-trigger:before {
  content: 'Ver más';
}

.read-more-state:checked~.read-more-trigger:before {
  content: 'Ver menos';
}
</style>